module.exports = __webpack_public_path__ + "img/avatarBig.184070a1.png";